import React, { FC, useMemo, useRef, useState } from 'react';

import { Button } from 'devextreme-react/button';
import DataGrid, {
  Column,
  ColumnChooser,
  Export,
  FilterPanel,
  FilterRow,
  GroupPanel,
  HeaderFilter,
  Lookup,
  Pager,
  Paging,
  StateStoring,
} from 'devextreme-react/data-grid';
import 'devextreme-react/text-area';

import { Template } from 'devextreme-react';
import { onExporting } from 'utils/exportingExcel';

import { AppCard, AppLayoutTop } from '../../../../components/appComponents';
import $createStore from '../../../../utils/create-store-instance';
import { CreateEditModal, DeleteModal } from './components';

const ConsumptionNomenclature: FC = () => {
  const consumptionNomenclatureDataStore: any = useMemo(() => {
    return $createStore('/v1/ConsumptionNomenclature/', 'id');
  }, []);

  const consumptionNomenclature = useMemo(() => {
    return $createStore('/v1/ConsumptionNomenclature/types', 'id');
  }, []);

  const factoryFullNames = useMemo(() => {
    return $createStore('/v1/factory/fullNames', 'id');
  }, []);

  const refGrid = useRef<DataGrid | null>(null);
  const [visibleDeleteModal, setVisibleDeleteModal] = useState(false);

  const [visibleModal, setVisibleModal] = useState(false);
  const [transportId, setTransportId] = useState<number | null>(null);
  const refreshGrid = () => refGrid.current?.instance.refresh();

  return (
    <div className="container-dev">
      <AppLayoutTop title="Расход материалов">
        <Button
          width={120}
          text="Создать"
          type="default"
          onClick={() => {
            setTransportId(null);
            setVisibleModal(true);
          }}
        />
      </AppLayoutTop>

      <CreateEditModal changeVisible={setVisibleModal} id={transportId} refresh={refreshGrid} visible={visibleModal} />

      <DeleteModal
        changeVisible={setVisibleDeleteModal}
        id={transportId}
        refresh={refreshGrid}
        visible={visibleDeleteModal}
      />

      <AppCard>
        <DataGrid
          dataSource={consumptionNomenclatureDataStore}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          key="id"
          ref={refGrid}
          remoteOperations
          allowColumnResizing
          columnResizingMode="nextColumn"
          columnMinWidth={50}
          allowColumnReordering
          onToolbarPreparing={(e) => {
            e.toolbarOptions?.items?.unshift({
              location: 'after',
              template: 'refresh',
            });
          }}
          onExporting={onExporting}
        >
          <StateStoring enabled={true} type="localStorage" storageKey="consumptionNomenclature" />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible />
          <GroupPanel visible={true} />
          <ColumnChooser enabled={true} />
          <Export enabled={true} />

          <Template name="refresh">
            <Button icon="refresh" onClick={refreshGrid} />
          </Template>

          <Column dataField="id" caption="Номер" sortOrder="asc" width={90} />
          <Column dataField="requestWorkNumber" caption="Номер отгрузки" />
          <Column dataField="date" caption="Дата" dataType="date" />
          <Column dataField="type" caption="Тип">
            <Lookup dataSource={consumptionNomenclature} valueExpr="id" displayExpr="name" />
          </Column>
          <Column dataField="materialName" caption="Материал" width={110} />
          <Column dataField="quantity" caption="Кол." />
          <Column dataField="unitName" caption="Ед. изм." width={110} />
          <Column dataField="nomenclatureName" caption="Марка бетона" width={110} />

          <Column dataField="factory" caption="Склад">
            <Lookup dataSource={factoryFullNames} valueExpr="id" displayExpr="name" />
          </Column>

          <Column dataField="comment" caption="Комментарий" />
          <Column
            dataField="actions"
            caption=""
            width={120}
            cellRender={(data) => (
              <>
                <Button
                  icon="edit"
                  type="default"
                  stylingMode="text"
                  onClick={() => {
                    setTransportId(data.data.id);
                    setVisibleModal(true);
                  }}
                />
                <Button
                  icon="trash"
                  type="default"
                  stylingMode="text"
                  onClick={() => {
                    setVisibleDeleteModal(true);
                    setTransportId(data.data.id);
                  }}
                />
              </>
            )}
          />
          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default ConsumptionNomenclature;
